var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfluenceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "(lc) logos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.56814 12.0504C0.402535 12.3205 0.216547 12.6339 0.0713243 12.8836C-0.0688031 13.123 0.00508229 13.4313 0.242025 13.5765L3.55413 15.6148C3.79362 15.7625 4.10699 15.6886 4.25476 15.4492C4.25476 15.4492 4.25731 15.4441 4.25986 15.4415C4.3898 15.2199 4.5605 14.932 4.74648 14.6237C6.05859 12.4581 7.38088 12.723 9.75795 13.8593L13.042 15.4211C13.2968 15.5409 13.6 15.4339 13.7223 15.1791C13.7223 15.174 13.7274 15.1689 13.7274 15.1664L15.3044 11.5995C15.4165 11.3447 15.3044 11.0466 15.0497 10.932C14.3567 10.6058 12.9783 9.95361 11.7376 9.35744C7.26368 7.18164 3.47005 7.32432 0.56814 12.0504Z",
    fill: "url(#paint0_linear_926_49876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4191 3.94832C15.5847 3.67826 15.7707 3.36233 15.9287 3.1152C16.0688 2.87571 15.9924 2.56743 15.7554 2.42221L12.4433 0.38399C12.2038 0.236219 11.8905 0.312653 11.7427 0.552143C11.7427 0.552143 11.7427 0.554691 11.7402 0.557239C11.6077 0.778895 11.437 1.06679 11.251 1.37507C9.93888 3.54068 8.61913 3.27571 6.23952 2.1394L2.94525 0.585264C2.69047 0.465519 2.38729 0.575073 2.26754 0.82985C2.26754 0.832398 2.26499 0.837493 2.26245 0.840041L0.685376 4.40692C0.573274 4.6617 0.685376 4.95979 0.940153 5.07444C1.63315 5.40055 3.01404 6.05023 4.25225 6.64896C8.72359 8.80692 12.5172 8.66424 15.4191 3.94832Z",
    fill: "url(#paint1_linear_926_49876)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_926_49876",
    x1: 15.2025,
    y1: 16.6619,
    x2: 5.18215,
    y2: 10.9014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0050D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#007FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_926_49876",
    x1: 0.779643,
    y1: -0.668239,
    x2: 10.8,
    y2: 5.08972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0050D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#007FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfluenceLogo);
export default __webpack_public_path__ + "static/media/confluence_logo.969d6149e4b415eaf81fd41a6dd80458.svg";
export { ForwardRef as ReactComponent };